module.exports = __webpack_public_path__ + "img/Picea_abies.a531f20a.jpg";